export default [

    {
        path: '',
        name: 'administracao',
        redirect: { name: 'administracao-home' },
    },

    {
        path: 'home',
        name: 'administracao-home',
        component: () => import('@/aplicacao/modulos/administracao/_Home'),
        meta: { autenticacao: true, permissao: 'ROLE_ADMINISTRACAO' },
    },

    {
        path: 'seguranca/senha-de-acesso',
        name: 'administracao-seguranca-senha-de-acesso',
        component: () => import('@/aplicacao/modulos/administracao/seguranca/SenhaDeAcesso'),
        meta: { autenticacao: true, permissao: 'ROLE_ADMINISTRACAO_SEGURANCA_SENHA_DE_ACESSO' },
    },

    {
        path: 'dashboard/carrossel',
        name: 'administracao-dashboard-carrossel',
        component: () => import('@/aplicacao/modulos/administracao/dashboard/carrossel/Carrossel'),
        meta: { autenticacao: true, permissao: 'ROLE_ADMINISTRACAO_DASHBOARD_CARROSSEL' },
    },

    {
        path: 'usuarios-templates',
        name: 'administracao-usuarios-templates-listar',
        component: () => import('@/aplicacao/modulos/administracao/usuarios-templates/Listar'),
        meta: { autenticacao: true, permissao: 'ROLE_ADMINISTRACAO_USUARIO_TEMPLATE' },
    },

    {
        path: 'usuarios-templates/criar',
        name: 'administracao-usuarios-templates-criar',
        component: () => import('@/aplicacao/modulos/administracao/usuarios-templates/Formulario'),
        meta: { autenticacao: true, permissao: 'ROLE_ADMINISTRACAO_USUARIO_TEMPLATE' },
    },

    {
        path: 'usuarios-templates/editar/:id',
        name: 'administracao-usuarios-templates-editar',
        component: () => import('@/aplicacao/modulos/administracao/usuarios-templates/Formulario'),
        meta: { autenticacao: true, permissao: 'ROLE_ADMINISTRACAO_USUARIO_TEMPLATE' },
    },

    {
        path: 'usuarios',
        name: 'administracao-usuarios-listar',
        component: () => import('@/aplicacao/modulos/administracao/usuarios/Listar'),
        meta: { autenticacao: true, permissao: 'ROLE_ADMINISTRACAO_USUARIO_USUARIO' },
    },

    {
        path: 'usuarios/criar',
        name: 'administracao-usuarios-criar',
        component: () => import('@/aplicacao/modulos/administracao/usuarios/Formulario'),
        meta: { autenticacao: true, permissao: 'ROLE_ADMINISTRACAO_USUARIO_USUARIO' },
    },

    {
        path: 'usuarios/editar/:id',
        name: 'administracao-usuarios-editar',
        component: () => import('@/aplicacao/modulos/administracao/usuarios/Formulario'),
        meta: { autenticacao: true, permissao: 'ROLE_ADMINISTRACAO_USUARIO_USUARIO' },
    },

    {
        path: 'marcas',
        name: 'administracao-marcas-listar',
        component: () => import('@/aplicacao/modulos/administracao/marcas/Listar'),
        meta: { autenticacao: true, permissao: 'ROLE_ADMINISTRACAO_MARCA' },
    },

    {
        path: 'marcas/criar',
        name: 'administracao-marcas-criar',
        component: () => import('@/aplicacao/modulos/administracao/marcas/Criar'),
        meta: { autenticacao: true, permissao: 'ROLE_ADMINISTRACAO_MARCA' },
    },

    {
        path: 'marcas/editar/:id',
        name: 'administracao-marcas-editar',
        component: () => import('@/aplicacao/modulos/administracao/marcas/Editar'),
        meta: { autenticacao: true, permissao: 'ROLE_ADMINISTRACAO_MARCA' },
    },

    {
        path: 'categorias',
        name: 'administracao-categorias-listar',
        component: () => import('@/aplicacao/modulos/administracao/categorias/Listar'),
        meta: { autenticacao: true, permissao: 'ROLE_ADMINISTRACAO_CATEGORIA' },
    },

    {
        path: 'categorias/criar',
        name: 'administracao-categorias-criar',
        component: () => import('@/aplicacao/modulos/administracao/categorias/Criar'),
        meta: { autenticacao: true, permissao: 'ROLE_ADMINISTRACAO_CATEGORIA' },
    },

    {
        path: 'categorias/editar/:id',
        name: 'administracao-categorias-editar',
        component: () => import('@/aplicacao/modulos/administracao/categorias/Editar'),
        meta: { autenticacao: true, permissao: 'ROLE_ADMINISTRACAO_CATEGORIA' },
    },

    {
        path: 'produto-tipos',
        name: 'administracao-produto-tipos-listar',
        component: () => import('@/aplicacao/modulos/administracao/produto-tipos/Listar'),
        meta: { autenticacao: true, permissao: 'ROLE_ADMINISTRACAO_PRODUTO_TIPO' },
    },

    {
        path: 'produto-tipos/criar',
        name: 'administracao-produto-tipos-criar',
        component: () => import('@/aplicacao/modulos/administracao/produto-tipos/Criar'),
        meta: { autenticacao: true, permissao: 'ROLE_ADMINISTRACAO_PRODUTO_TIPO' },
    },

    {
        path: 'produto-tipos/editar/:id',
        name: 'administracao-produto-tipos-editar',
        component: () => import('@/aplicacao/modulos/administracao/produto-tipos/Editar'),
        meta: { autenticacao: true, permissao: 'ROLE_ADMINISTRACAO_PRODUTO_TIPO' },
    },

    {
        path: 'produto-familias',
        name: 'administracao-produto-familias-listar',
        component: () => import('@/aplicacao/modulos/administracao/produto-familias/Listar'),
        meta: { autenticacao: true, permissao: 'ROLE_ADMINISTRACAO_PRODUTO_FAMILIA' },
    },

    {
        path: 'produto-familias/criar',
        name: 'administracao-produto-familias-criar',
        component: () => import('@/aplicacao/modulos/administracao/produto-familias/Criar'),
        meta: { autenticacao: true, permissao: 'ROLE_ADMINISTRACAO_PRODUTO_FAMILIA' },
    },

    {
        path: 'produto-familias/editar/:id',
        name: 'administracao-produto-familias-editar',
        component: () => import('@/aplicacao/modulos/administracao/produto-familias/Editar'),
        meta: { autenticacao: true, permissao: 'ROLE_ADMINISTRACAO_PRODUTO_FAMILIA' },
    },

    {
        path: 'produto-temperaturas',
        name: 'administracao-produto-temperaturas-listar',
        component: () => import('@/aplicacao/modulos/administracao/produto-temperaturas/Listar'),
        meta: { autenticacao: true, permissao: 'ROLE_ADMINISTRACAO_PRODUTO_TEMPERATURA' },
    },

    {
        path: 'produto-temperaturas/criar',
        name: 'administracao-produto-temperaturas-criar',
        component: () => import('@/aplicacao/modulos/administracao/produto-temperaturas/Criar'),
        meta: { autenticacao: true, permissao: 'ROLE_ADMINISTRACAO_PRODUTO_TEMPERATURA' },
    },

    {
        path: 'produto-temperaturas/editar/:id',
        name: 'administracao-produto-temperaturas-editar',
        component: () => import('@/aplicacao/modulos/administracao/produto-temperaturas/Editar'),
        meta: { autenticacao: true, permissao: 'ROLE_ADMINISTRACAO_PRODUTO_TEMPERATURA' },
    },

    {
        path: 'produtos',
        name: 'administracao-produtos-listar',
        component: () => import('@/aplicacao/modulos/administracao/produtos/Listar'),
        meta: { autenticacao: true, permissao: 'ROLE_ADMINISTRACAO_PRODUTO' },
    },

    {
        path: 'produtos/criar',
        name: 'administracao-produtos-criar',
        component: () => import('@/aplicacao/modulos/administracao/produtos/formulario/Formulario'),
        meta: { autenticacao: true, permissao: 'ROLE_ADMINISTRACAO_PRODUTO' },
    },

    {
        path: 'produtos/editar/:id',
        name: 'administracao-produtos-editar',
        component: () => import('@/aplicacao/modulos/administracao/produtos/formulario/Formulario'),
        meta: { autenticacao: true, permissao: 'ROLE_ADMINISTRACAO_PRODUTO' },
    },

    {
        path: 'banco-de-midias/categorias',
        name: 'administracao-banco-de-midias-categorias-listar',
        component: () => import('@/aplicacao/modulos/administracao/banco-de-midias/categorias/Listar'),
        meta: { autenticacao: true, permissao: 'ROLE_ADMINISTRACAO_BANCO_DE_MIDIAS' },
    },

    {
        path: 'banco-de-midias/categorias/criar',
        name: 'administracao-banco-de-midias-categorias-criar',
        component: () => import('@/aplicacao/modulos/administracao/banco-de-midias/categorias/Criar'),
        meta: { autenticacao: true, permissao: 'ROLE_ADMINISTRACAO_BANCO_DE_MIDIAS' },
    },

    {
        path: 'banco-de-midias/categorias/editar/:id',
        name: 'administracao-banco-de-midias-categorias-editar',
        component: () => import('@/aplicacao/modulos/administracao/banco-de-midias/categorias/Editar'),
        meta: { autenticacao: true, permissao: 'ROLE_ADMINISTRACAO_BANCO_DE_MIDIAS' },
    },

    {
        path: 'banco-de-midias/midias',
        name: 'administracao-banco-de-midias-midias-listar',
        component: () => import('@/aplicacao/modulos/administracao/banco-de-midias/midias/Listar'),
        meta: { autenticacao: true, permissao: 'ROLE_ADMINISTRACAO_BANCO_DE_MIDIAS' },
    },

    {
        path: 'banco-de-midias/midias/criar',
        name: 'administracao-banco-de-midias-midias-criar',
        component: () => import('@/aplicacao/modulos/administracao/banco-de-midias/midias/Criar'),
        meta: { autenticacao: true, permissao: 'ROLE_ADMINISTRACAO_BANCO_DE_MIDIAS' },
    },

    {
        path: 'banco-de-midias/midias/editar/:id',
        name: 'administracao-banco-de-midias-midias-editar',
        component: () => import('@/aplicacao/modulos/administracao/banco-de-midias/midias/Editar'),
        meta: { autenticacao: true, permissao: 'ROLE_ADMINISTRACAO_BANCO_DE_MIDIAS' },
    },

    {
        path: 'banco-de-midias/logos-de-marcas',
        name: 'administracao-banco-de-midias-logos-de-marcas-listar',
        component: () => import('@/aplicacao/modulos/administracao/banco-de-midias/logos-de-marcas/Listar'),
        meta: { autenticacao: true, permissao: 'ROLE_ADMINISTRACAO_BANCO_DE_MIDIAS' },
    },

    {
        path: 'banco-de-midias/logos-de-marcas/criar',
        name: 'administracao-banco-de-midias-logos-de-marcas-criar',
        component: () => import('@/aplicacao/modulos/administracao/banco-de-midias/logos-de-marcas/Criar'),
        meta: { autenticacao: true, permissao: 'ROLE_ADMINISTRACAO_BANCO_DE_MIDIAS' },
    },

    {
        path: 'banco-de-midias/logos-de-marcas/editar/:id',
        name: 'administracao-banco-de-midias-logos-de-marcas-editar',
        component: () => import('@/aplicacao/modulos/administracao/banco-de-midias/logos-de-marcas/Editar'),
        meta: { autenticacao: true, permissao: 'ROLE_ADMINISTRACAO_BANCO_DE_MIDIAS' },
    },

    {
        path: 'material-de-apoio/categorias',
        name: 'administracao-material-de-apoio-categorias-listar',
        component: () => import('@/aplicacao/modulos/administracao/material-de-apoio/categorias/Listar'),
        meta: { autenticacao: true, permissao: 'ROLE_ADMINISTRACAO_MATERIAL_DE_APOIO' },
    },

    {
        path: 'material-de-apoio/categorias/criar',
        name: 'administracao-material-de-apoio-categorias-criar',
        component: () => import('@/aplicacao/modulos/administracao/material-de-apoio/categorias/Criar'),
        meta: { autenticacao: true, permissao: 'ROLE_ADMINISTRACAO_MATERIAL_DE_APOIO' },
    },

    {
        path: 'material-de-apoio/categorias/editar/:id',
        name: 'administracao-material-de-apoio-categorias-editar',
        component: () => import('@/aplicacao/modulos/administracao/material-de-apoio/categorias/Editar'),
        meta: { autenticacao: true, permissao: 'ROLE_ADMINISTRACAO_MATERIAL_DE_APOIO' },
    },

    {
        path: 'material-de-apoio/midias',
        name: 'administracao-material-de-apoio-midias-listar',
        component: () => import('@/aplicacao/modulos/administracao/material-de-apoio/midias/Listar'),
        meta: { autenticacao: true, permissao: 'ROLE_ADMINISTRACAO_MATERIAL_DE_APOIO' },
    },

    {
        path: 'material-de-apoio/midias/criar',
        name: 'administracao-material-de-apoio-midias-criar',
        component: () => import('@/aplicacao/modulos/administracao/material-de-apoio/midias/Criar'),
        meta: { autenticacao: true, permissao: 'ROLE_ADMINISTRACAO_MATERIAL_DE_APOIO' },
    },

    {
        path: 'material-de-apoio/midias/editar/:id',
        name: 'administracao-material-de-apoio-midias-editar',
        component: () => import('@/aplicacao/modulos/administracao/material-de-apoio/midias/Editar'),
        meta: { autenticacao: true, permissao: 'ROLE_ADMINISTRACAO_MATERIAL_DE_APOIO' },
    },

    {
        path: 'encartes/temas',
        name: 'administracao-encartes-temas-listar',
        component: () => import('@/aplicacao/modulos/administracao/encartes/temas/Listar'),
        meta: { autenticacao: true, permissao: 'ROLE_ADMINISTRACAO_ENCARTE_TEMA' },
    },

    {
        path: 'encartes/temas/ordenar',
        name: 'administracao-encartes-temas-ordenar',
        component: () => import('@/aplicacao/modulos/administracao/encartes/temas/Ordenar'),
        meta: { autenticacao: true, permissao: 'ROLE_ADMINISTRACAO_ENCARTE_TEMA' },
    },

    {
        path: 'encartes/temas/criar',
        name: 'administracao-encartes-temas-criar',
        component: () => import('@/aplicacao/modulos/administracao/encartes/temas/Criar'),
        meta: { autenticacao: true, permissao: 'ROLE_ADMINISTRACAO_ENCARTE_TEMA' },
    },

    {
        path: 'encartes/temas/editar/:id',
        name: 'administracao-encartes-temas-editar',
        component: () => import('@/aplicacao/modulos/administracao/encartes/temas/Editar'),
        meta: { autenticacao: true, permissao: 'ROLE_ADMINISTRACAO_ENCARTE_TEMA' },
    },

    {
        path: 'encartes-virtuais/temas',
        name: 'administracao-encartes-virtuais-temas-listar',
        component: () => import('@/aplicacao/modulos/administracao/encartes-virtuais/temas/Listar'),
        meta: { autenticacao: true, permissao: 'ROLE_ADMINISTRACAO_ENCARTE_VIRTUAL_TEMA' },
    },

    {
        path: 'encartes-virtuais/temas/ordenar',
        name: 'administracao-encartes-virtuais-temas-ordenar',
        component: () => import('@/aplicacao/modulos/administracao/encartes-virtuais/temas/Ordenar'),
        meta: { autenticacao: true, permissao: 'ROLE_ADMINISTRACAO_ENCARTE_VIRTUAL_TEMA' },
    },

    {
        path: 'encartes-virtuais/temas/criar',
        name: 'administracao-encartes-virtuais-temas-criar',
        component: () => import('@/aplicacao/modulos/administracao/encartes-virtuais/temas/Criar'),
        meta: { autenticacao: true, permissao: 'ROLE_ADMINISTRACAO_ENCARTE_VIRTUAL_TEMA' },
    },

    {
        path: 'encartes-virtuais/temas/editar/:id',
        name: 'administracao-encartes-virtuais-temas-editar',
        component: () => import('@/aplicacao/modulos/administracao/encartes-virtuais/temas/Editar'),
        meta: { autenticacao: true, permissao: 'ROLE_ADMINISTRACAO_ENCARTE_VIRTUAL_TEMA' },
    },

    {
        path: 'box/temas',
        name: 'administracao-box-temas-listar',
        component: () => import('@/aplicacao/modulos/administracao/box/temas/Listar'),
        meta: { autenticacao: true, permissao: 'ROLE_ADMINISTRACAO_BOX_TEMA' },
    },

    {
        path: 'box/temas/ordenar',
        name: 'administracao-box-temas-ordenar',
        component: () => import('@/aplicacao/modulos/administracao/box/temas/Ordenar'),
        meta: { autenticacao: true, permissao: 'ROLE_ADMINISTRACAO_BOX_TEMA' },
    },

    {
        path: 'box/temas/criar',
        name: 'administracao-box-temas-criar',
        component: () => import('@/aplicacao/modulos/administracao/box/temas/Criar'),
        meta: { autenticacao: true, permissao: 'ROLE_ADMINISTRACAO_BOX_TEMA' },
    },

    {
        path: 'box/temas/editar/:id',
        name: 'administracao-box-temas-editar',
        component: () => import('@/aplicacao/modulos/administracao/box/temas/Editar'),
        meta: { autenticacao: true, permissao: 'ROLE_ADMINISTRACAO_BOX_TEMA' },
    },

    {
        path: 'midias-sociais/artes',
        name: 'administracao-midias-sociais-artes-listar',
        component: () => import('@/aplicacao/modulos/administracao/midias-sociais/artes/Listar'),
        meta: { autenticacao: true, permissao: 'ROLE_ADMINISTRACAO_MIDIA_SOCIAL_ARTES' },
    },

    {
        path: 'midias-sociais/artes/ordenar',
        name: 'administracao-midias-sociais-artes-ordenar',
        component: () => import('@/aplicacao/modulos/administracao/midias-sociais/artes/Ordenar'),
        meta: { autenticacao: true, permissao: 'ROLE_ADMINISTRACAO_MIDIA_SOCIAL_ARTES' },
    },

    {
        path: 'midias-sociais/artes/criar',
        name: 'administracao-midias-sociais-artes-criar',
        component: () => import('@/aplicacao/modulos/administracao/midias-sociais/artes/Criar'),
        meta: { autenticacao: true, permissao: 'ROLE_ADMINISTRACAO_MIDIA_SOCIAL_ARTES' },
    },

    {
        path: 'midias-sociais/artes/editar/:id',
        name: 'administracao-midias-sociais-artes-editar',
        component: () => import('@/aplicacao/modulos/administracao/midias-sociais/artes/Editar'),
        meta: { autenticacao: true, permissao: 'ROLE_ADMINISTRACAO_MIDIA_SOCIAL_ARTES' },
    },

    {
        path: 'artes-digitais/artes-base',
        name: 'administracao--artes-digitais--artes-base--listar',
        component: () => import('@/aplicacao/modulos/administracao/artes-digitais/artes-base/listar/Listar'),
        meta: { autenticacao: true, permissao: 'ROLE_ADMINISTRACAO_ARTES_DIGITAIS_ARTES_BASE' },
    },

    {
        path: 'artes-digitais/artes-base/ordenar',
        name: 'administracao--artes-digitais--artes-base--ordenar',
        component: () => import('@/aplicacao/modulos/administracao/artes-digitais/artes-base/ordenar/Ordenar'),
        meta: { autenticacao: true, permissao: 'ROLE_ADMINISTRACAO_ARTES_DIGITAIS_ARTES_BASE' },
    },

    {
        path: 'artes-digitais/artes-base/formulario/:id?',
        name: 'administracao--artes-digitais--artes-base--formulario',
        component: () => import('@/aplicacao/modulos/administracao/artes-digitais/artes-base/Formulario'),
        meta: { autenticacao: true, permissao: 'ROLE_ADMINISTRACAO_ARTES_DIGITAIS_ARTES_BASE' },
    },

    {
        path: 'artes-digitais/formatos-presets',
        name: 'administracao--artes-digitais--formatos-presets--listar',
        component: () => import('@/aplicacao/modulos/administracao/artes-digitais/formatos-presets/Listar'),
        meta: { autenticacao: true, permissao: 'ROLE_ADMINISTRACAO_ARTES_DIGITAIS_FORMATO_PRESET' },
    },

    {
        path: 'artes-digitais/formatos-presets/formulario/:id?',
        name: 'administracao--artes-digitais--formatos-presets--formulario',
        component: () => import('@/aplicacao/modulos/administracao/artes-digitais/formatos-presets/Formulario'),
        meta: { autenticacao: true, permissao: 'ROLE_ADMINISTRACAO_ARTES_DIGITAIS_FORMATO_PRESET' },
    },

]
